import { FC, useEffect, useState } from "react";
import { FieldValues, UseFormWatch } from "react-hook-form";
import FormSelect from "../../../components/molecule/Select/FormSelect";
import { getIndicator } from "../../../services/Indicator/getIndicator";
import RadioControlGroup from "../../../components/molecule/RadioControlGroup/RadioControlGroup";
import { getGraphTypes } from "../../../services/Graph/getGraphTypes";
import { Button, Flex, VStack } from "@chakra-ui/react";
import AccordionComponent from "../../../components/atom/Accordion/AccordionComponent";

interface AccordionGraphFieldProps {
  control: any;
  errors: any;
  watch: UseFormWatch<FieldValues>;
  index: number;
  remove: () => void;
}

const AccordionGraphField: FC<AccordionGraphFieldProps> = ({
  control,
  errors,
  watch,
  index,
  remove,
}) => {
  const [indicatorName, setIndicatorName] = useState<string | null>(null);
  const selectedIndicator = watch(`graphs[${index}].indicatorOptions`);

  useEffect(() => {
    if (selectedIndicator?.name) {
      setIndicatorName(selectedIndicator.name);
    } else {
      setIndicatorName(null);
    }
  }, [selectedIndicator]);

  const accordionTitle = indicatorName
    ? `GRÁFICO ${index + 1} | ${indicatorName.toUpperCase()}`
    : `GRÁFICO ${index + 1}`;

  return (
    <AccordionComponent accordionTitle={accordionTitle} fontSize="sm">
      <Flex alignItems="flex-end" justifyContent="space-between">
        <VStack gap="4">
          <FormSelect
            control={control}
            errors={errors}
            watch={watch}
            fieldName={`graphs[${index}].indicatorOptions`}
            fieldLabel="Seleccione o indicador"
            fetchOptions={getIndicator}
          />
          <RadioControlGroup
            errors={errors}
            control={control}
            fetchOptions={getGraphTypes}
            fieldName="Seleccione o formato"
            name={`graphs[${index}].typeOption`}
            isRequired
          />
        </VStack>
        <Button variant="secondary" colorScheme="red" onClick={remove}>
          Eliminar gráfico
        </Button>
      </Flex>
    </AccordionComponent>
  );
};

export default AccordionGraphField;
